import React from 'react';
import styled from 'styled-components';
import I10n from '../../features/i10n';
import DescriptionModal from '../../features/modals/modal-description-text';
import InformationIcon from '../../atoms/information-icon';

const HintIcon = styled.span`
  position: relative;
  display: inline-block;
  margin-left: 5px;
  color: #6D6F75;
  cursor: pointer;
`;

class ComparatorValueHintMobile extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
  }

  toggleModal = (event) => {
    event.stopPropagation();
    this.setState({ showModal: !this.state.showModal });
  }

  render() {

    return (
      <HintIcon onClick={this.toggleModal}>
        <InformationIcon size="small"></InformationIcon>
        <DescriptionModal
          title={I10n.getOrDefault(`screen.licence_selector.comparator_value.name.${this.props.comparatorValue.labelKey}`, this.props.comparatorValue.value)}
          text={I10n.getOrDefault(`screen.licence_selector.comparator_value.name.${this.props.comparatorValue.labelKey}.hint`, this.props.comparatorValue.hint)}
          show={this.state.showModal}
          onClose={this.toggleModal}
        />
      </HintIcon>
    );
  }
}

export default ComparatorValueHintMobile;
